// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-odds+.item-odds[data-v-5a98b338]{border-top:1px solid #e0e0e0}.v-card[data-v-5a98b338]:nth-child(1){border-radius:20px 20px 15px 15px !important;border:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
